/**
 * Results State Layer
 * Unified state management for search results and collection pages
 * Delegates filter/sort/pagination operations to SDK helpers
 */

class ResultsStateLayer {
	constructor () {
		this.eventBus = window.theme.tagalys.results.eventBus

		this.state = {
			products: [],
			facets: [],
			activeFacets: [],
			sortOptions: [],
			pagination: {},
			searchParams: ''
		}

		this.subscribeToEvents()
	}

	subscribeToEvents () {
		// Initialize filters from URL when API is ready
		this.eventBus.subscribe('results:api:initialized', () => {
			this.initializeFiltersFromURL()
		})

		// Handle API success response
		this.eventBus.subscribe('results:api:fetched:success', (response) => {
			const products = response.products
			const facets = response.filters
			const sortOptions = response.sort_options

			const requestParams = this.SDK.helpers.getRequestParams()
			const searchParams = this.SDK.helpers.getEncodedQueryString(requestParams)

			const pagination = {
				page: response.page,
				size: response.per_page,
				total: response.total_count
			}

			this.products = products
			this.facets = facets
			this.sortOptions = sortOptions
			this.pagination = pagination
			this.searchParams = searchParams

			this.eventBus.publish('results:state:products:updated', this.state.products)
			this.eventBus.publish('results:state:sortOptions:updated', this.state.sortOptions)
			this.eventBus.publish('results:state:facets:updated', this.state.facets)
		})

		// Handle facet addition
		this.eventBus.subscribe('results:ui:facet:added', ({ field, value }) => {
			this.eventBus.publish('results:state:loading')
			this.SDK.helpers.applyFilter(field, value)
		})

		// Handle facet removal
		this.eventBus.subscribe('results:ui:facet:removed', ({ field, value }) => {
			this.eventBus.publish('results:state:loading')
			this.SDK.helpers.clearFilter(field, value)
		})

		// Handle clear all facets
		this.eventBus.subscribe('results:ui:facet:clearAll', () => {
			this.eventBus.publish('results:state:loading')
			this.SDK.helpers.clearAllFilters()
			window.history.replaceState({}, '', window.location.pathname)
		})

		// Handle pagination changes
		this.eventBus.subscribe('results:ui:pagination:changed', (cursor) => {
			this.eventBus.publish('results:state:loading')

			if (cursor.direction === 'next') {
					this.SDK.helpers.goToNextPage()
			} else {
					this.SDK.helpers.goToPreviousPage()
			}
		})

		const tabPanel = document.querySelector('section[is="tab-panel"]');

		if (this.products.length === 0 && tabPanel) {
			document.querySelector('section[is="tab-panel"]').removeAttribute('hidden')
		}
	}

	initializeFiltersFromURL () {
		const requestParams = this.SDK.helpers.getRequestParamsFromQueryString(window.location.search)
		const filters = requestParams.filters

		if (filters) {
			this.SDK.helpers.applyFilter(filters)
		}
	}

	get SDK () {
		return window.theme.tagalys.results.SDK
	}

	get facets () {
		return this.state.facets
	}

	get products () {
		return this.state.products
	}

	set products (products) {
		this.state.products = products
	}

	set facets (facets) {
		this.state.facets = facets
	}

	get searchParams () {
		return this.state.searchParams
	}

	set searchParams (searchParams) {
		const sanitizedSearchParams = searchParams.replace('query=', 'q=')
		window.history.replaceState({}, '', window.location.pathname + '?' + sanitizedSearchParams)
		this.state.searchParams = searchParams
	}

	get sortOptions () {
		return this.state.sortOptions
	}

	set sortOptions (sortOptions) {
		this.state.sortOptions = sortOptions
	}

	get pagination () {
		return this.state.pagination
	}

	set pagination (pagination) {
		this.state.pagination = pagination
	}

	get SDK () {
		return window.theme.tagalys.results.SDK
	}
}

window.theme.tagalys.results.stateLayer = new ResultsStateLayer()
